<section class="atw-page contact-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">

    <!-- Hero -->
    <div class="contact-hero">
      <div class="contact-hero-content">
        <div class="hero-badge">
          <span>{{ 'atw.contact.hero.badgeNumber' | transloco }}</span>
          {{ 'atw.contact.hero.badgeTitle' | transloco }}
        </div>

        <h1>
          {{ 'atw.contact.hero.titleLine1' | transloco }}
          <strong>{{ 'atw.contact.hero.titleStrong' | transloco }}</strong>
        </h1>

        <p>
          {{ 'atw.contact.hero.description' | transloco }}
        </p>

        <div class="hero-actions">
          <a class="primary-action" href="tel:+201033750675">
            {{ 'atw.contact.hero.callBtn' | transloco }}
          </a>

          <a
            class="secondary-action"
            href="https://maps.app.goo.gl/Yp3V36RCxrBAygFr6?g_st=iw"
            target="_blank"
            rel="noopener noreferrer"
          >

            {{ 'atw.contact.hero.mapBtn' | transloco }}
                        <img class="img-m" src="assets/as/47.webp" alt="map" />
          </a>
        </div>
      </div>

      <div class="contact-hero-visual">
        <div class="contact-visual-card">
          <div class="contact-visual-icon">
            <img class="img-l" src="assets/as/38.webp" alt="call" />
          </div>

          <strong>{{ 'atw.contact.hero.visualTitle' | transloco }}</strong>
          <p>{{ 'atw.contact.hero.visualText' | transloco }}</p>
        </div>

        <div class="floating-card contact-floating-card">
          <img class="img-m" src="assets/as/21.webp" alt="location" />

          <div>
            <strong>{{ 'atw.contact.hero.floatTitle' | transloco }}</strong>
            <small>{{ 'atw.contact.hero.floatText' | transloco }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Info -->
    <section class="apply-section" id="contact-info">
      <div class="section-title">
        <span>
          <b>{{ 'atw.contact.info.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.contact.info.title' | transloco }}</h2>
          <p>{{ 'atw.contact.info.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="contact-info-grid">
        <article
          class="apply-card contact-info-card"
          *ngFor="let item of contactCards; trackBy: trackByContactCard"
        >
          <div class="contact-card-icon">
            <img
              class="img-m"
              [src]="item.iconImg"
              [alt]="item.labelKey | transloco"
            />
          </div>

          <div>
            <span class="contact-card-label">{{ item.labelKey | transloco }}</span>
            <h3>{{ item.titleKey | transloco }}</h3>
            <p>{{ item.textKey | transloco }}</p>

            <div class="contact-card-actions">
              <a
                *ngIf="item.href"
                class="primary-action contact-mini-action"
                [href]="item.href"
                [target]="item.external ? '_blank' : null"
                [rel]="item.external ? 'noopener noreferrer' : null"
              >

                {{ item.actionKey | transloco }}
              </a>

              <button
                type="button"
                class="secondary-action contact-mini-action"
                (click)="copyText(item.copyValue, item.id)"
              >


                {{
                  copiedKey === item.id
                    ? ('atw.contact.actions.copied' | transloco)
                    : ('atw.contact.actions.copy' | transloco)
                }}
                                <img
                  class="img-m"
                  [src]="copiedKey === item.id ? 'assets/as/30.webp' : 'assets/as/30.webp'"
                  alt="copy"
                />
              </button>
            </div>
          </div>
        </article>
      </div>
    </section>

    <!-- Official Channels -->
    <section class="apply-section" id="official-channels">
      <div class="section-title">
        <span>
          <b>{{ 'atw.contact.channels.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.contact.channels.title' | transloco }}</h2>
          <p>{{ 'atw.contact.channels.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card contact-channels-card">
        <a
          class="contact-channel"
          *ngFor="let channel of officialChannels; trackBy: trackByChannel"
          [href]="channel.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="channel-icon">
            <img
              class="img-m"
              [src]="channel.iconImg"
              [alt]="channel.labelKey | transloco"
            />
          </div>

          <div>
            <span>{{ channel.labelKey | transloco }}</span>
            <strong>{{ channel.titleKey | transloco }}</strong>
            <small>{{ channel.textKey | transloco }}</small>
          </div>

          <b>
            <img class="img-m" src="assets/as/3.webp" alt="open" />
          </b>
        </a>
      </div>
    </section>

    <!-- CTA -->
    <section class="apply-section">
      <div class="apply-card contact-cta">
        <div>
          <span class="contact-cta-badge">{{ 'atw.contact.cta.badge' | transloco }}</span>
          <h2>{{ 'atw.contact.cta.title' | transloco }}</h2>
          <p>{{ 'atw.contact.cta.text' | transloco }}</p>
        </div>

        <a
          class="primary-action"
          href="https://wa.me/201033750675"
          target="_blank"
          rel="noopener noreferrer"
        >

          {{ 'atw.contact.cta.btn' | transloco }}
        </a>
      </div>
    </section>

  </div>
</section>